import Form from '@/classes/Form' ;

window.LoginModule = (function($){

    const settings = {
        loginForm: $('#js-login-form'),
        resetForm: $('#js-reset-form'),
        inviteCodeForm: $('#js-invite-form'),
        newsletterForm: $('.newsletter-form'),
        currentRoute: window.location.pathname
    }

    const init = () => {
        const _s = settings;

        _s.loginForm.on('submit', submitLogin)
        _s.resetForm.on('submit', submitReset)
        _s.inviteCodeForm.on('submit', submiteInviteCode)
        _s.newsletterForm.on('submit', submitNewsletter)

    }

    function submitLogin(e) {

        e.preventDefault();

        let emailError = document.getElementById('email-error');
        let passwordError = document.getElementById('password-error');
        let submitButton = $('#js-login-form button[type=submit]');

        emailError.textContent = ""
        passwordError.textContent = ""
        submitButton.prop('disabled', true);
        submitButton.addClass('disabled')

        let form = new Form({
            email: $("input[name='email']").val(),
            password: $("input[name='password']").val()
        })

        form.post('/login')
            .then(response => {
                window.location.href = $("input[name='previousurl']").val();
            })
            .catch(errors => {

                submitButton.removeClass('disabled')
                submitButton.prop('disabled', false);

                if (form.errors.has('email')) {
                    emailError.textContent = form.errors.email
                }
                if (form.errors.has('password')) {
                    passwordError.textContent = form.errors.password
                }
            })
    }

    function submitReset(e) {
        e.preventDefault(); // avoid to execute the actual submit of the form.

        let emailError = document.getElementById('reset-email-error');
        let submitButton = $('#js-reset-form button[type=submit]')

        emailError.textContent = ""
        submitButton.prop('disabled', true);
        submitButton.addClass('disabled')

        let form = new Form({
            email: $("input[name='forgot_password_email']").val()
        })

        form.post(`/password/email`)
            .then(response => {
                console.log(response)
                $(`<span class="success">${response.success}</span>`)
                    .insertAfter($("#js-reset-form .button"))
                    .hide()
                    .fadeIn(500);
            })
            .catch(errors => {
                submitButton.prop('disabled', false);
                submitButton.removeClass('disabled')
                emailError.textContent = form.errors.email
            })
    }

    function submiteInviteCode(e) {
        e.preventDefault();

        let inviteCodeError = document.getElementById('invite-code-error');
        let submitButton = $('#js-invite-form button[type=submit]')

        inviteCodeError.textContent = ""
        submitButton.prop('disabled', true)

        let form = new Form({
            invite_code: $("input[name='invite_code']").val()
        })

        form.post(`/invite-code`)
            .then(response => {
                window.location.href = window.location.origin + '/apply?invite_code=' + response.invite_code;
            })
            .catch(errors => {
                inviteCodeError.textContent = form.errors.invite_code
                submitButton.prop('disabled', false)
            })
    }

    function submitNewsletter(e) {

        e.preventDefault();

        let submitButton = $('.newsletter-formbutton[type=submit]')
        let messageContent = $('.newsletter-form .message');

        messageContent.html('').hide().removeClass('success error');
        submitButton.prop('disabled', true);

        let form = new Form({
            email: $(this).find("input[name='newsletter_email']").val()
        })

        form.post(`/gate/newsletter`)
            .then(response => {
                messageContent.addClass('success').show().html(response.success);
            })
            .catch(errors => {
                submitButton.prop('disabled', false);
                messageContent.addClass('error').show().html(form.errors.email);
            })
    }

    return { init }

})(jQuery)
